import { ActionAPI, FormAPI, PanelAPI } from '@philips-emr/tws-components';
import { HistoryService, MessageService } from '@philips-emr/tws-core/lib/services';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import { ProviderAccreditationPendenciesService, ProviderAccreditationStatusService, ToastServiceProviderAccreditation } from '..';

export class FormViewService {

  public static shouldRenderForm(api: PanelAPI, step?: string): void {
    const { nrSeqUser, nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    ProviderAccreditationStatusService.getAccreditationStatus(nrSeqAccreditation as number, nrSeqUser as number).then((response) => {
      const { status } = response.body;
      if (status == '1' || status == '3') {
        if (status == '3') {
          void ProviderAccreditationPendenciesService.getPendencies(nrSeqAccreditation as number, nrSeqUser as number, 'R', step).then((resp) => {
            if (isEmptyArrayOrObject(resp.body)) {
              api.setVisible(false);
            }
          }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
        }
      } else {
        api.setVisible(false);
      }
    }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
  }

  public static shouldEditForm(api: FormAPI, step?: string): void {
    const { nrSeqUser, nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    ProviderAccreditationStatusService.getAccreditationStatus(nrSeqAccreditation as number, nrSeqUser as number).then((response) => {
      const { status } = response.body;
      if (status == '1' || status == '3') {
        if (step && status == '3') {
          ProviderAccreditationPendenciesService.getPendencies(nrSeqAccreditation as number, nrSeqUser as number, 'R', step).then((resp) => {
            if (isEmptyArrayOrObject(resp.body)) {
              api.setEditing(false);
              api.setLocked(true);
              return;
            }
          }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
        }
        api.setEditing(true);
        api.setLocked(false);
      } else {
        api.setEditing(false);
        api.setLocked(true);
      }
    }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
  }

  public static shouldRenderAction(api: ActionAPI, step?: string): void {
    const { nrSeqUser, nrSeqAccreditation } = HistoryService.getCurrentRouteParams();
    ProviderAccreditationStatusService.getAccreditationStatus(nrSeqAccreditation as number, nrSeqUser as number).then((response) => {
      const { status } = response.body;
      if (status == '1' || status == '3') {
        if (status == '3') {
          ProviderAccreditationPendenciesService.getPendencies(nrSeqAccreditation as number, nrSeqUser as number, 'R', step).then((resp) => {
            if (isEmptyArrayOrObject(resp.body)) {
              api.setEnabled(false);
            }
          }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
        }

      } else {
        api.setEnabled(false);
      }
    }).catch(() => ToastServiceProviderAccreditation.error(MessageService.translate('pa.error-process-request')));
  }

}
